import React from 'react';

const RightArrowIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.52461 12.9746C6.38711 12.8371 6.31836 12.6621 6.31836 12.4496C6.31836 12.2371 6.38711 12.0621 6.52461 11.9246L9.44961 8.99961L6.52461 6.07461C6.38711 5.93711 6.31836 5.76211 6.31836 5.54961C6.31836 5.33711 6.38711 5.16211 6.52461 5.02461C6.66211 4.88711 6.83711 4.81836 7.04961 4.81836C7.26211 4.81836 7.43711 4.88711 7.57461 5.02461L11.0246 8.47461C11.0996 8.54961 11.1527 8.63086 11.184 8.71836C11.2152 8.80586 11.2309 8.89961 11.2309 8.99961C11.2309 9.09961 11.2152 9.19336 11.184 9.28086C11.1527 9.36836 11.0996 9.44961 11.0246 9.52461L7.57461 12.9746C7.43711 13.1121 7.26211 13.1809 7.04961 13.1809C6.83711 13.1809 6.66211 13.1121 6.52461 12.9746Z"
        fill="#84818A"
      />
    </svg>
  );
};

export default RightArrowIcon;
